function LogoSmall() {
  return <img src="/icons/stars.svg" alt="logo" />;
}

export default LogoSmall;
